import React from "react";
import { RegisterOptions } from "react-hook-form";
import { FormItem, NumberField } from "..";
import { NumberControlProps } from "./NumberControl.types";
import { GetChildrePropsParams } from "../FormItem/FormItem.types";

function NumberControl(props: NumberControlProps) {
  const {
    defaultValue,
    getNumberFieldProps,
    hideHelperText,
    label,
    max,
    min,
    name,
    required,
    validate,
    value,
    valuePropName,
    watchValue,
    ...other
  } = props;

  const rules = React.useMemo<RegisterOptions>(() => {
    const result: RegisterOptions = {};
    const validateNumber = (value?: any) => {
      if (value && typeof value !== "number") {
        return label ? `${label} is not a number` : "Field is not a number";
      }
    };
    if (validate) {
      if (typeof validate === "function") {
        result.validate = {
          number: validateNumber,
          custom: validate,
        };
      } else if (typeof validate === "object") {
        result.validate = {
          number: validateNumber,
          ...validate,
        };
      }
    } else {
      result.validate = validateNumber;
    }
    if (required) {
      result.required = {
        value: true,
        message: label ? `${label} is required` : "Required field",
      };
    }
    if (min !== undefined) {
      result.min = {
        value: min,
        message: `The minimum is ${min}`,
      };
    }
    if (max !== undefined) {
      result.max = {
        value: max,
        message: `The maximum is ${max}`,
      };
    }
    return result;
  }, [label, max, min, required, validate]);

  const getChildrenProps = React.useCallback(
    (params: GetChildrePropsParams) => {
      return getNumberFieldProps?.(params);
    },
    [getNumberFieldProps]
  );

  return (
    <FormItem
      defaultValue={defaultValue}
      getChildrenProps={getChildrenProps}
      hideHelperText={hideHelperText}
      name={name}
      rules={rules}
      valuePropName={valuePropName}
      watchValue={watchValue}
    >
      <NumberField {...other} label={label} value={value} />
    </FormItem>
  );
}

export default React.memo(NumberControl);
